// extracted by mini-css-extract-plugin
export default {"container":"q91i"};